<template>
  <v-card class="elevation-12 pa-6" min-height="300" width="400">
    <v-toolbar flat height="150">
      <v-col class="d-flex justify-space-around">
        <v-toolbar-title>
          <v-img
            class="ma-auto py-2"
            :src="logoURL"
            contain
            max-width="120"
          ></v-img>
          <h3 class="py-2" style="font-size: 24px;">Gestión de Vehículos</h3>
        </v-toolbar-title>
      </v-col>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field
          label="Usuario"
          name="usuario"
          prepend-icon="person"
          type="text"
          v-model="username"
          @keyup.enter="ingreso"
          :disabled="loading"
        ></v-text-field>
        <v-text-field
          :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
          :disabled="loading"
          :type="show_password ? 'text' : 'password'"
          @click:append="show_password = !show_password"
          @keyup.enter="ingreso"
          label="Contraseña"
          maxlength="12"
          name="password"
          prepend-icon="lock"
          v-model="password"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-container>
        <v-row dense>
          <v-col cols="12">
            <v-btn
              color="primary"
              @click="ingreso"
              width="100%"
              :disabled="loading"
              >Ingresar</v-btn
            >
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-btn
              color="primary"
              @click="recupero"
              width="100%"
              :disabled="loading"
              >Recup. Contraseña</v-btn
            >
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-btn
              color="primary"
              @click="registro"
              width="100%"
              :disabled="loading"
              >Regístrate</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import qs from "qs";
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      show_password: false,
      logoURL: process.env.VUE_APP_BASE_PATH + `/api/config/GetImagen?id=logo`
    };
  },
  methods: {
    ...mapActions(["setToken", "setLogin", "showAlerta", "hideAlerta"]),
    async ingreso() {
      this.hideAlerta();

      if (this.username == "") {
        this.showAlerta({
          mensaje: "Ingrese usuario",
          tipo: 3
        });
        return;
      }

      if (this.password == "") {
        this.showAlerta({
          mensaje: "Ingrese password",
          tipo: 3
        });
        return;
      }

      let respuesta;

      try {
        this.loading = true;
        respuesta = await axios({
          method: "post",
          url: process.env.VUE_APP_BASE_PATH + "/api/token",
          data: qs.stringify({
            grant_type: "password",
            username: this.username,
            password: this.password
          }),
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=utf-8"
          }
        });
      } catch (error) {
        this.loading = false;
        this.showAlerta({
          mensaje: error.response.data.error_description,
          tipo: 3
        });
        return;
      } finally {
        this.loading = false;
      }

      this.setToken(respuesta.data.access_token);
      this.setLogin(true);
      this.$router.push({ path: "/Index" });
    },
    recupero() {
      this.hideAlerta();
      this.$router.push("Recupero");
    },
    registro() {
      this.hideAlerta();
      this.$router.push("Registro");
    }
  }
};
</script>

<style scoped>
h3 {
  font-weight: 500;
}
</style>
